import React from "react";

import { fileUpload, handleEditorChange, prepareEditorContentImage } from "utils";

import { LANGUAGES, LANGUAGE_CODE } from "consts";

import { Col, Form, Input, Option, Row, Select, TextArea, TextEditor, UploadImage } from "components";

export const NewsInputs = ({
  content,
  imageSuccess,
  imageURL,
  modules,
  methods,
  news,
  setContent,
  setImageSuccess,
  setImageURL,
  setLoading,
  tags,
  reloadTags,
}) => (
  <>
    <Row>
      <Col>
        <Form.Item name="image" rules={[{ required: true }]} initialValue={news ? news.image : undefined}>
          <UploadImage
            imageSuccess={imageSuccess}
            imageUrl={imageURL}
            label="Add image"
            beforeUpload={(v) => fileUpload(v, "news", setImageSuccess, setImageURL, setLoading)}
          />
        </Form.Item>
      </Col>
    </Row>
    <Row>
      <Col sm={24} md={24}>
        <Input name="altImageText" rules={[{ required: !!imageURL }]} label="Alt Image Text" initialValue={news?.altImageText ?? ""} />
      </Col>
    </Row>
    <Row>
      <Col sm={24} md={12}>
        <Input name="title" label="News title" rules={[{ required: true }]} initialValue={news ? news.title : ""} />
      </Col>
      <Col sm={12} md={4}>
        <Select name="language" label="Language" rules={[{ required: true }]} initialValue={news ? news.language : LANGUAGE_CODE.GERMAN} onChange={reloadTags}>
          {LANGUAGES.filter((language) => language.showOnAdmin).map((language, index) => (
            <Option key={index} value={language.code.toLowerCase()}>
              {language.language}
            </Option>
          ))}
        </Select>
      </Col>
      <Col sm={12} md={4}>
        <Select name="active" label="Visibility" rules={[{ required: true }]} initialValue={news ? news.active : false}>
          <Option value={true}>Enabled</Option>
          <Option value={false}>Disabled</Option>
        </Select>
      </Col>
      <Col sm={12} md={4}>
        <Select name="usersOnly" label="Access" rules={[{ required: true }]} initialValue={news ? news.usersOnly : false}>
          <Option value={true}>Users only</Option>
          <Option value={false}>Everyone</Option>
        </Select>
      </Col>
    </Row>
    <Row>
      <Col sm={24} md={24}>
        <Select
          name="tags"
          label="Select tags"
          rules={[{ required: true }]}
          mode="tags"
          style={{ width: "100%" }}
          initialValue={
            news
              ? news.tags.reduce((a, { tag }) => {
                  a.push(tag);
                  return a;
                }, [])
              : undefined
          }
        >
          {tags.map((item, i) => (
            <Option value={item} key={i}>
              {item}
            </Option>
          ))}
        </Select>
      </Col>
      <Col sm={24} md={12}>
        <Select
          name="methods"
          label="Select a method"
          style={{ width: "100%" }}
          rules={[{ required: false }]}
          initialValue={news && news.methods[0] ? news.methods[0].method : undefined}
        >
          <Option value={null}>None</Option>
          {methods.map((item, i) => (
            <Option value={item} key={i}>
              {item}
            </Option>
          ))}
        </Select>
      </Col>
      <Col sm={24} md={12}>
        <Select
          name="modules"
          label="Select a module"
          style={{ width: "100%" }}
          rules={[{ required: false }]}
          initialValue={news && news.modules[0] ? news.modules[0].module : undefined}
        >
          <Option value={null}>None</Option>
          {modules.map((item, i) => (
            <Option value={item} key={i}>
              {item}
            </Option>
          ))}
        </Select>
      </Col>
    </Row>
    <Row>
      <Col sm={24} md={24}>
        <Input name="htmlTitle" label="HTML Title (max. 60)" initialValue={news?.htmlTitle ?? ""} maxLength={60} />
      </Col>
    </Row>
    <Row>
      <Col sm={24} md={24}>
        <TextArea name="htmlDescription" label="HTML Description (max. 155)" initialValue={news?.htmlDescription ?? ""} maxLength={155} />
      </Col>
    </Row>
    <Row>
      <Col>
        <TextEditor
          init={{
            images_upload_handler: (blobInfo, success) => {
              prepareEditorContentImage({ file: blobInfo.blob(), location: "news" }).then((res) => success(res));
            },
          }}
          initialValue={news ? news.content : ""}
          onEditorChange={(v) => handleEditorChange(v, setContent)}
          value={content}
        />
      </Col>
    </Row>
  </>
);
